/** =========================================================
 * Contractors controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-contractors')
    .controller('ContractorsController', ContractorsController);

  ContractorsController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate'];

  function ContractorsController($rootScope, $scope, $api, $state, $stateParams, $translate) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page contractors',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'contractor',
        getDataParams: {
          order: {
            id: 'desc'
          },
          count: ['projects']
        },
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Title',
          key: 'name',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-contractor.html'
        },
        edit: {
          template: 'app/views/dialogs/item-contractor.html',
          except: ['projects_count']
        },
        delete: {},
        linkButtons: [{
          title: 'Projects',
          icon: 'icon-folder-alt',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('project view'),
          action: function (item) {
            try {
              $state.go('app.page-projects', {
                filters: [{
                  name: $translate.instant('Contractor') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['contractor_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.projects_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
